import useSWR from 'swr'
import { learningApi } from 'services/api'
import { useSelector } from 'react-redux'
import { RootState } from 'store/modules/rootReducer'
import { TVideoAnnotation } from './types'

interface IParams {
  courseId: string
  objectId: string
}

export function useGetVideoAnnotations(params: IParams) {
  const { courseId, objectId } = params

  const { token } = useSelector((state: RootState) => state.auth)

  const url = '/annotation/get-annotation'

  const body = {
    course: { _id: courseId },
    apprenticeshipObject: { _id: objectId },
  }

  const shouldFetch = !!token && !!objectId

  const key = [url, body, token]

  return useSWR<TVideoAnnotation[]>(shouldFetch ? key : null, fetcher, {
    fallbackData: [],
    dedupingInterval: 10e3, // 10 seconds
  })
}

const fetcher = ([url, body, token]: [string, Record<string, any>, string]) =>
  learningApi
    .post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)
